import React, { Component } from 'react';
import { connect } from 'react-redux'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';
import { INTEGRATION, DRAGGABLE_WINDOWS, ASSISTED_TRANSFER } from '../../../constants.js';
import { ivr } from '../../../Images/CallSpaceHeaderSVG'
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { callAction } from '../../../redux/actions/A_reducer_call_acd';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { messageOngoingCallIvr } from '../../../redux/actions/A_messages_to_SM';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import ModalActions from '../../../redux/actions/A_ongoing_call_ivr_modal';
import { Logger } from '../../../js/helpers/Logger';

class OngoingCallIvrWindow extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
    this.state = {
      IvrArray: []
    };
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.assistedTransfer.currentState && nextProps.assistedTransfer.currentState === ASSISTED_TRANSFER.IDDLE_END) {
      let integrationMessage = { client: "galatea", action: "OngoingCallIvr", subaction: "onIdleEnd" };
      SingletonWebSocket.send(integrationMessage);
      this.props.hideModal();
    }
    if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration) {
      if (nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.IDLE_START) {
        let _this = this;
        _this.sendToIvr(nextProps.messagesIntegrations.dataMessageIntegration.IVRId);
      }
      else if (nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.CALL_ACTION && nextProps.messagesIntegrations.dataMessageIntegration.callAction === INTEGRATION.GET_IVR_LIST) {
        let _this = this;
        let message = [];        
        for (var i in _this.state.IvrArray) {
          let item = _this.state.IvrArray[i];
          message.push({ name: item.Description, id: item.Id });
        }
        let integrationMessage = { client: "galatea", data: message, action: "OngoingCallIvr", subaction: "onIVRList" };
        SingletonWebSocket.send(integrationMessage);
      }
    }
  }

  componentDidMount() {
    let objectResponse = this.apiCont.getObjectResponse();
    this.apiCont.ongoingCallIvr(objectResponse);
    let _this = this;
    objectResponse.onError = function (messageError) {
      Logger.Debug(`[Ongoing Call Window][componentDidMount] Api Controller ERROR  =>  ${messageError}`,);
    };
    objectResponse.onSuccess = function (objResponse) {
      Logger.Trace(`[Ongoing Call Window][componentDidMount] Api Controller On Going Call IVR Success`);
      let message = [];      
      for (var i in objResponse) {
        let item = objResponse[i];
        message.push({ name: item.Description, id: item.Id });
      }

      let integrationMessage = { client: "galatea", data: message, action: "OngoingCallIvr", subaction: "onIVRList" };
      SingletonWebSocket.send(integrationMessage);
      _this.setState({ IvrArray: objResponse });
    };
    if (_this.props.objProps && _this.props.objProps.action && _this.props.objProps.action === INTEGRATION.IDLE_START) {
      _this.sendToIvr(_this.props.objProps.IVRId);
    }
  }
  sendToIvr(id) {
    this.props.messageOngoingCallIvr(id);
    let integrationMessage = { client: "galatea", action: "OngoingCallIvr", data: id, subaction: "onIdleStart" };
    SingletonWebSocket.send(integrationMessage);
    let data = {
      message: this.language.getText("CallControlIVRInputmessage"),
      title: this.language.getText("CallControlIVRInputtitle")
    }
    setTimeout(() => { this.props.showModal(data) }, 200);
    this.props.onCloseIVR && this.props.onCloseIVR();
    setTimeout(() => { this.props.removeWindow(DRAGGABLE_WINDOWS.ONGOING_CALL_IVR) }, 400);
  }
  renderList(item, i) {
    return <div key={i} className="OngoingCallIvrElement" onClick={() => this.sendToIvr(item.Id)}>{item.Description}</div>;
  }
  render() {
    return (
      <div className="OngoingCallIvrWindow" onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](ivr,
          this.language.getText("CallControlIVRInputheader"),
          () => {
            this.props.onCloseIVR && this.props.onCloseIVR();
            this.props.removeWindow(DRAGGABLE_WINDOWS.ONGOING_CALL_IVR)}
        )}
        <div className="OngoingCallIvrContainer">
          {this.state.IvrArray.map((item, i) =>
            this.renderList(item, i))}
        </div>
      </div>
    );
  }
};
function mapStateToProps(state) {
  return {
    messagesIntegrations: state.messagesIntegrations,
    assistedTransfer: state.assistedTransfer,
  }
}
function mapDispatchToProps(dispatch) {
  const { showModal, hideModal } = ModalActions.creators;
  return ({
    messageOngoingCallIvr: (data) => { dispatch(messageOngoingCallIvr(data)); },
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    callAction: (actionType, parameters) => { dispatch(callAction(actionType, parameters)); },
    showModal: (data) => { dispatch(showModal(data)); },
    hideModal: () => { dispatch(hideModal()); }
  });
}
export default OngoingCallIvrWindow = connect(
  mapStateToProps,
  mapDispatchToProps
)(OngoingCallIvrWindow);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/OngoingCallIvrWindow.jsx